import moment from "moment"
import { UpOutlined, DownOutlined } from '@ant-design/icons'
import { withTranslation } from "react-i18next"
import { useState, useEffect } from "react"
import { Descriptions, Image, Input, Form, Comment, List, Button, Divider, message, Tag } from "antd"

import { post, get } from "library/endpoints"

const { TextArea } = Input;

const Editor = ({ onChange, onSubmit, submitting, value }) => (
  <>
    <Form.Item>
      <TextArea rows={4} onChange={onChange} value={value} />
    </Form.Item>
    <Form.Item>
      <Button htmlType="submit" onClick={onSubmit} loading={submitting} type="primary">
        Ajouter une réponse
      </Button>
    </Form.Item>
  </>
);



const Entry = (props) => {
  const [display, setDisplay] = useState(false)
  const [replies, setReplies] = useState([])
  const [reply, setReply] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    fetchData()
  }, []) // eslint-disable-line

  const entry = props.entry

  const fetchData = async () => {
    try {
      const response = await get(`/frontend/help-desk/replies/${entry._id}`);
      setReplies(response.data)

    } catch (error) {
      message.error('Erreur lors de la récupération des réponses')
    }
  }

  const _renderAuthor = (reply) => {
    if (reply.reply_from === 'shop') {
      return (
        <>
          {<>Réponse boutique</>}
        </>
      )
    } else {
      return (
        <>
          Réponse du client
        </>
      )
    }
  }


  const handleOnSubmitReply = async () => {
    try {
      setSubmitting(true)
      await post(`/frontend/help-desk/reply/${entry._id}`, {
        reply
      });
      setReply(null)
      setSubmitting(false)
      fetchData();
    } catch (error) {
      setSubmitting(false)
      console.log(error)
      message.error('Une erreur s est produite')
    }
  }

  return (
    <div>
      <div style={{ display: 'flex', borderBottom: '1px solid lightgrey', padding: 10, cursor: 'pointer' }} onClick={() => setDisplay(!display)}>
        Ticket du {moment(props.entry.created_at).format('DD/MM/YYYY')}
        <div style={{ marginLeft: 'auto' }}>
          {
            display ? (
              <UpOutlined />
            ) : (
              <DownOutlined />
            )
          }
        </div>
      </div>
      {
        display && (
          <>
            <Descriptions bordered title="Informations" style={{ background: 'white', borderRadius: 5, padding: 10 }}>
              <Descriptions.Item label="Statut">
              {entry.status ? (<Tag color="green">Cloturé</Tag>) : (<Tag color="red">Ouvert</Tag>)}
              </Descriptions.Item>

              <Descriptions.Item label="Catégorie">{entry._category.category.fr}</Descriptions.Item>
              <Descriptions.Item label="Facture">
                {
                  entry._billing ? (
                    <div>{`${entry._billing.invoice_label}`}</div>
                  ) : (
                    <div>Non renseigné</div>
                  )
                }
              </Descriptions.Item>
              <Descriptions.Item label="Message">{`${entry.message}`}</Descriptions.Item>
              
              {
                entry.photo && (
                  <Descriptions.Item label="Photo du défaut"><Image src={`${process.env.REACT_APP_S3_FILES_URL}${entry.photo}`} width={100} /></Descriptions.Item>
                )
              }

              {
                entry.product_photo && (
                  <Descriptions.Item label="Photo du produit"><Image src={`${process.env.REACT_APP_S3_FILES_URL}${entry.product_photo}`} width={100} /></Descriptions.Item>
                )
              }
            </Descriptions>


            <Divider />
              <h3>{props.t('Admin.Helpdesk.Edit.Replies', 'Réponses')}</h3>

              <List
                className="comment-list"
                style={{ background: 'white', padding: 10, borderRadius: 5 }}
                header={`${replies.length} réponse(s)`}
                itemLayout="horizontal"
                dataSource={replies}
                renderItem={(reply) => (
                  <li>
                    <Comment
                      actions={[]}
                      author={_renderAuthor(reply)}
                      content={
                        <p>
                          {reply.reply}
                        </p>
                      }
                      datetime={moment(reply.created_at).format('DD/MM/YYYY HH:mm')}
                    />
                  </li>
                )}
              />
              {
                entry.status === false && (
                  <Comment 
                    content={
                      <Editor
                        onChange={(e) => setReply(e.target.value)}
                        onSubmit={handleOnSubmitReply}
                        submitting={submitting}
                        value={reply}
                      />
                    }
                  />
                )
              }
          </>
        )
      }
    </div>
  )
}

export default withTranslation()(Entry)